import t from '@instructure/quiz-i18n/format-message';
export var standardDeviation = {
  title: t('Standard Deviation'),
  body: t('Standard deviation is a measure of the average absolute deviation of scores around the mean. A low standard deviation indicates, on average, the scores tend to be close to the mean of the set. A high value indicates, on average, scores vary widely from the mean of the data set.'),
  screenReaderLabel: t('Standard deviation tooltip')
};
export var cronbachsAlpha = {
  title: t("Cronbach's Alpha"),
  body: t("Cronbach's alpha is an internal consistency measure that estimates the reliability of a quiz. Values range from 0 to 1, with higher values indicating greater reliability."),
  screenReaderLabel: t("Cronbach's alpha tooltip")
};